import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import EmptyStateCard from "../../../../components/EmptyStateCard";
import useEvents from "../../../../hooks/useEvents";

type EmptyAlertGroupsProps = {
  onAddGroup: () => void;
};

const EmptyAlertGroups = ({ onAddGroup }: EmptyAlertGroupsProps) => {
  const events = useEvents();
  
  return (
    <Box data-testid="EmptyAlertGroupsView" style={{ margin: 24 }}>
      <EmptyStateCard
        text="No alert groups yet. Alert groups let you send one-way notifications that appear in your clients' mobile apps."
      />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500 }}>
          <Typography style={{ textAlign: "center", marginBottom: 16 }}>
            Alert groups are perfect for announcements, reminders, or important 
            information that you need all your clients to see. Messages appear 
            as alert boxes in the client mobile app.
          </Typography>
          <StandardButton
            data-testid="EmptyAlertGroupsView-Button"
            variant="primary"
            onClick={() => {
              onAddGroup();
              events.logButtonClick({
                buttonName: "Create Your First Alert Group",
                pageName: "Messages",
                tabName: "Alert Groups Empty",
              });
            }}
            style={{ fontSize: 18 }}
          >
            Create Your First Alert Group
          </StandardButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default EmptyAlertGroups;